import React from "react";

interface ImagingPanelProps {
  value: string;
  onChange: (value: string) => void;
}

export const ImagingPanel: React.FC<ImagingPanelProps> = ({
  value,
  onChange,
}) => (
  <div className="border-b border-slate-200 p-4 bg-amber-50">
    <h3 className="text-sm font-semibold text-amber-800 mb-2">Imaging</h3>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Enter imaging findings..."
      className="w-full h-24 text-sm border border-amber-200 rounded-lg p-2 bg-white placeholder-amber-300 focus:outline-none focus:ring-2 focus:ring-amber-400 resize-none"
    />
  </div>
);
